import { useState, useEffect } from "react";
import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Hamburger from "hamburger-react";


function Header() {
  const [isOpen, setOpen] = useState(false);
  const [role, setRole] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setRole(localStorage.getItem("role")); // Get role from localStorage
  }, []);

  const department = localStorage.getItem("department_name")
  const image_url = localStorage.getItem("image_url")

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("username")
    localStorage.removeItem("place")
    localStorage.removeItem("department_name")
    localStorage.removeItem("image_url")
    localStorage.removeItem("device_ids")
    navigate("/");
  };

  // Hide the entire navigation on these pages
  const hideNavOnPages = ["/login", "/register"];

  return (
<>
  {/* Header */}
  <div className="flex justify-between items-center w-full p-4 bg-white shadow-md">
    {/* Logo and Department Name */}
    <div className="flex items-center">
      <img className="w-20 h-14 object-contain" src={image_url} alt="Logo" />
      <h2 className="text-xl font-semibold text-gray-800">{department}</h2>
    </div>

    {/* Desktop Navigation */}
    <div className="hidden lg:flex items-center gap-6">
      {!hideNavOnPages.includes(location.pathname) && (
        <>
          <Link to="/home">
            <button className="text-black font-semibold rounded px-3 py-2 hover:bg-gray-100">Home</button>
          </Link>

          {role === "admin" && (
            <>
              <Link to="/admin/dashboard">
                <button className="text-black font-semibold rounded px-3 py-2 hover:bg-gray-100">Add Device</button>
              </Link>
              <Link to="/Create-user/">
                <button className="text-black font-semibold rounded px-3 py-2 hover:bg-gray-100">Add User</button>
              </Link>
              <Link to="/recharge">
                <button className="text-black font-semibold rounded px-3 py-2 hover:bg-gray-100">Recharge</button>
              </Link>
              <Link to="/Admin">
                <button className="text-black font-semibold rounded px-3 py-2 hover:bg-gray-100">Profile</button>
              </Link>
              
            </>
          )}

          {role === "user" && (
            <>
              <Link to="/clients">
                <button className="text-black font-semibold rounded px-3 py-2 hover:bg-gray-100">Profile</button>
              </Link>
              <Link to="/data/reports">
                <button className="text-black font-semibold rounded px-3 py-2 hover:bg-gray-100">Download</button>
              </Link>
               <Link to="/Forecast">
                <button className="text-black font-semibold rounded px-3 py-2 hover:bg-gray-100">Forecast</button>
              </Link>
              <button
                onClick={handleLogout}
                className="text-black font-semibold rounded px-3 py-2 hover:bg-gray-100"
              >
                Logout
              </button>
            </>
          )}
        </>
      )}
    </div>

    {/* Mobile Menu Button */}
    <button className="lg:hidden" onClick={() => setOpen(!isOpen)}>
      <Hamburger toggled={isOpen} toggle={setOpen} />
    </button>
  </div>

  {/* Mobile Sidebar */}
  {isOpen && (
    <div className="fixed top-0 right-0 w-3/4 h-full bg-blue-300 shadow-lg z-50 p-4 lg:hidden rounded-l-3xl">
      <button onClick={() => setOpen(false)} className="text-4xl text-white font-bold self-end">×</button>
      <nav className="flex flex-col text-white items-start mt-6 space-y-4">
        {!hideNavOnPages.includes(location.pathname) && (
          <>
            <Link to="/home" onClick={() => setOpen(false)} className="text-xl">Home</Link>

            {role === "admin" && (
              <>
                <Link to="/admin/dashboard" onClick={() => setOpen(false)} className="text-xl">Add Device</Link>
                <Link to="/Create-user/" onClick={() => setOpen(false)} className="text-xl">Add User</Link>
                <Link to="/reports" onClick={() => setOpen(false)}>
                  <button className="bg-blue-800 text-white font-bold rounded px-2 py-1">Reports</button>
                </Link>
                <Link to="/data/reports">
                <button className="text-black font-semibold rounded px-3 py-2 hover:bg-gray-100">Download</button>
              </Link>
                <Link to="/Forecast">
                <button className="text-black font-semibold rounded px-3 py-2 hover:bg-gray-100">Forecast</button>
              </Link>
              </>
            )}

            {role === "user" && (
              <>
                <Link to="/clients" onClick={() => setOpen(false)} className="text-xl">Profile</Link>
                <button
                  onClick={() => {
                    handleLogout();
                    setOpen(false);
                  }}
                  className="text-white text-xl"
                >
                  Logout
                </button>
              </>
            )}
          </>
        )}
      </nav>
    </div>
  )}
</>

  );
}

export default Header;
